/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { ChevronNextIcon } from '@coursera/cds-icons';

import TrackedButton from 'bundles/page/components/TrackedButton';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  label: string | React.ReactElement;
  name: string;
  className?: string;
  href?: string;
  ariaLabel?: string;
  trackingName?: string;
  onButtonClick?: () => void;
};

const styles = {
  menuItem: css`
    list-style-type: none;
  `,
  link: css`
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: left;
    position: relative;
    padding: var(--cds-spacing-50) var(--cds-spacing-100);
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  button: css`
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: left;
    position: relative;
    padding: var(--cds-spacing-100);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: black;
  `,
};

const MobileButton = ({ label, name, className, href, ariaLabel, trackingName, onButtonClick }: Props) => {
  return (
    <li css={styles.menuItem}>
      {href ? (
        <TrackedA
          className={className}
          tabIndex={0}
          href={href}
          role="menuitem"
          trackingName={trackingName ?? 'mobile_header_button'}
          data={{ name }}
          css={styles.link}
          onClick={onButtonClick}
          data-testid="mobile-header-button"
        >
          <Typography2 component="p" variant="bodyPrimary">
            {label}
          </Typography2>
        </TrackedA>
      ) : (
        <TrackedButton
          className={className}
          onClick={() => {
            onButtonClick?.();
          }}
          key={`mobileNav~${label}`}
          trackingName={trackingName ?? 'mobile_header_button'}
          data={{ name }}
          aria-label={ariaLabel}
          tabIndex={0}
          css={styles.button}
          data-testid="mobile-header-button"
        >
          <Typography2 component="p" variant="bodyPrimary">
            {label}
          </Typography2>
          <ChevronNextIcon size="medium" />
        </TrackedButton>
      )}
    </li>
  );
};

export default MobileButton;
